import React, { useState, useEffect } from 'react';
import bg from '../../../assets/menuflor.jpg';
import Post from '../../../utils/Post copy';
import VainillaDialog from '../../sharecomponents/vanilladialog';
import AdministradorDePerfiles from './Components/AdministradorDePerfiles';
import CambioPasswordUser from './Components/CambioPasswordUser';
import AdministradorDeUsuarios from './Components/AdministradorDeUsuarios';
import AjusteTipoSemana from './Components/AjusteTipoSemana';
import { getUser, activeDialog } from '../../../utils/Common';

const Settings = () => {
    const [password_form, setpassword_form] = useState({ password: "", new_password: "" });
    const [dialog, setdialog] = useState({ show: false });
    const [loader, setloader] = useState(false);
    const userType = (getUser() ?? { perfil: { nombre: "" } }).perfil.nombre.toLowerCase();
    const [change, setchange] = useState(0);

    const show_dialog = (title = "", body = "", type = 'error', size = "m") => {
        setdialog({
            show: true,
            tipo: type,
            title: title,
            body: body,
            size: size,
            funct: () => { setdialog({ show: false }) }
        });
    }

    return (
        <div className='vw-100 p-2 overflow bg-white p-2 dosis overflow ' style={{ height: "calc( 100vh - 60px)", backgroundImage: `url(${bg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
            <div className='row justify-content-evenly w-100 m-0 mb-4 p-0'>
                {['usuario', 'administrador'].includes(userType) && <AdministradorDeUsuarios show_dialog={show_dialog} change={change} refresh={() => setchange(change + 1)} />}
                <div className='w-100 m-2'></div>
                {['usuario', 'administrador'].includes(userType) && <AdministradorDePerfiles show_dialog={show_dialog} change={change} refresh={() => setchange(change + 1)} />}
                <div className='w-100 mb-5'></div>
                <CambioPasswordUser show_dialog={show_dialog} />
                <div className='w-100 m-0 p-0' />
                <AjusteTipoSemana show_dialog={show_dialog} loader={setloader} />
            </div>
            {loader && <div className='blur-s' style={{ width: '100vw', height: '100vh', position: 'fixed', left: 0, top: 0 }}><div className='loader'></div></div>}
            <VainillaDialog data={dialog} />
        </div>
    )
}

export default Settings;